import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
function f(e) {
	return e instanceof Date ? e.toISOString() : String(e);
}
var p = class extends t {
	instance;
	baseUrl;
	jsonParseReviver;
	constructor(e, t) {
		super(), this.instance = t ?? n.create(), this.baseUrl = e ?? "http://127.0.0.1:7087/Support";
	}
	disconnectRexListing(e, t) {
		let r = this.baseUrl + "/DisconnectRexListing", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processDisconnectRexListing(e)));
	}
	processDisconnectRexListing(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? M("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 403 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 409 ? M("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAgentIntegrationStatus(e, t, r) {
		let i = this.baseUrl + "/GetAgentIntegrationStatus";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		if (i += "agencyId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'agentId' must be defined and cannot be null.");
		i += "agentId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetAgentIntegrationStatus(e)));
	}
	processGetAgentIntegrationStatus(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? M("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAutomationFailure(e, t) {
		let r = this.baseUrl + "/GetAutomationFailure";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'reference' must be defined and cannot be null.");
		r += "reference=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetAutomationFailure(e)));
	}
	processGetAutomationFailure(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAutomationFailureMetrics(e, t) {
		let r = this.baseUrl + "/GetAutomationFailureMetrics";
		if (r += "?", e === null) throw new globalThis.Error("The parameter 'campaignId' cannot be null.");
		e !== void 0 && (r += "campaignId=" + encodeURIComponent(f(e)) + "&"), r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetAutomationFailureMetrics(e)));
	}
	processGetAutomationFailureMetrics(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAutomationFailures(e, t, r, i, a, o, s, c, l, u, d) {
		let p = this.baseUrl + "/GetAutomationFailures";
		if (p += "?", e === null) throw new globalThis.Error("The parameter 'search' cannot be null.");
		if (e !== void 0 && (p += "search=" + encodeURIComponent(f(e)) + "&"), t === null) throw new globalThis.Error("The parameter 'area' cannot be null.");
		if (t !== void 0 && (p += "area=" + encodeURIComponent(f(t)) + "&"), r === null) throw new globalThis.Error("The parameter 'reason' cannot be null.");
		if (r !== void 0 && (p += "reason=" + encodeURIComponent(f(r)) + "&"), i === null) throw new globalThis.Error("The parameter 'agencyId' cannot be null.");
		if (i !== void 0 && (p += "agencyId=" + encodeURIComponent(f(i)) + "&"), a === null) throw new globalThis.Error("The parameter 'campaignId' cannot be null.");
		if (a !== void 0 && (p += "campaignId=" + encodeURIComponent(f(a)) + "&"), o === null) throw new globalThis.Error("The parameter 'status' cannot be null.");
		if (o !== void 0 && (p += "status=" + encodeURIComponent(f(o)) + "&"), s === null) throw new globalThis.Error("The parameter 'occurredFromUtc' cannot be null.");
		if (s !== void 0 && (p += "occurredFromUtc=" + encodeURIComponent(f(s)) + "&"), c === null) throw new globalThis.Error("The parameter 'occurredToUtc' cannot be null.");
		if (c !== void 0 && (p += "occurredToUtc=" + encodeURIComponent(f(c)) + "&"), l === null) throw new globalThis.Error("The parameter 'continuationToken' cannot be null.");
		if (l !== void 0 && (p += "continuationToken=" + encodeURIComponent(f(l)) + "&"), u === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
		u !== void 0 && (p += "pageSize=" + encodeURIComponent(f(u)) + "&"), p = p.replace(/[?&]$/, "");
		let m = {
			method: "GET",
			url: p,
			headers: { Accept: "application/json" },
			signal: d
		};
		return this.transformOptions(m).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(p, e, (e) => this.processGetAutomationFailures(e)));
	}
	processGetAutomationFailures(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCommonInformationForMessage(e, t, r, i, a) {
		let o = this.baseUrl + "/GetCommonInformationForMessage";
		if (o += "?", e === null) throw new globalThis.Error("The parameter 'agentId' cannot be null.");
		if (e !== void 0 && (o += "agentId=" + encodeURIComponent(f(e)) + "&"), t === null) throw new globalThis.Error("The parameter 'agencyId' cannot be null.");
		if (t !== void 0 && (o += "agencyId=" + encodeURIComponent(f(t)) + "&"), r === null) throw new globalThis.Error("The parameter 'campaignId' cannot be null.");
		if (r !== void 0 && (o += "campaignId=" + encodeURIComponent(f(r)) + "&"), i === null) throw new globalThis.Error("The parameter 'userId' cannot be null.");
		i !== void 0 && (o += "userId=" + encodeURIComponent(f(i)) + "&"), o = o.replace(/[?&]$/, "");
		let s = {
			method: "GET",
			url: o,
			headers: { Accept: "application/json" },
			signal: a
		};
		return this.transformOptions(s).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(o, e, (e) => this.processGetCommonInformationForMessage(e)));
	}
	processGetCommonInformationForMessage(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getLeaderboardVisibilityDetails(e, t) {
		let r = this.baseUrl + "/GetLeaderboardVisibilityDetails";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetLeaderboardVisibilityDetails(e)));
	}
	processGetLeaderboardVisibilityDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getLogsForServiceAtPeriod(e, t, r) {
		let i = this.baseUrl + "/GetLogsForServiceAtPeriod";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'agxService' must be defined and cannot be null.");
		if (i += "agxService=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'timeToSearchNear' must be defined and cannot be null.");
		i += "timeToSearchNear=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetLogsForServiceAtPeriod(e)));
	}
	processGetLogsForServiceAtPeriod(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getManualDocuSignUpdateCampaignDetails(e, t) {
		let r = this.baseUrl + "/GetManualDocuSignUpdateCampaignDetails";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetManualDocuSignUpdateCampaignDetails(e)));
	}
	processGetManualDocuSignUpdateCampaignDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getMigrations(e) {
		let t = this.baseUrl + "/GetMigrations", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetMigrations(e)));
	}
	processGetMigrations(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getPoisonQueueMessages(e, t, r) {
		let i = this.baseUrl + "/GetPoisonQueueMessages";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'agxService' must be defined and cannot be null.");
		if (i += "agxService=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'queueName' must be defined and cannot be null.");
		i += "queueName=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetPoisonQueueMessages(e)));
	}
	processGetPoisonQueueMessages(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getPoisonQueues(e) {
		let t = this.baseUrl + "/GetPoisonQueues", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetPoisonQueues(e)));
	}
	processGetPoisonQueues(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getRexDisconnectionCampaignDetails(e, t) {
		let r = this.baseUrl + "/GetRexDisconnectionCampaignDetails";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetRexDisconnectionCampaignDetails(e)));
	}
	processGetRexDisconnectionCampaignDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? M("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 403 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getSoftDeletedAgentsForAgency(e, t) {
		let r = this.baseUrl + "/GetSoftDeletedAgentsForAgency";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetSoftDeletedAgentsForAgency(e)));
	}
	processGetSoftDeletedAgentsForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getUpdateCampaignStatusDetails(e, t) {
		let r = this.baseUrl + "/GetUpdateCampaignStatusDetails";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetUpdateCampaignStatusDetails(e)));
	}
	processGetUpdateCampaignStatusDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	getUpdateLegalNameCampaignDetails(e, t) {
		let r = this.baseUrl + "/GetUpdateLegalNameCampaignDetails";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetUpdateLegalNameCampaignDetails(e)));
	}
	processGetUpdateLegalNameCampaignDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	reopenAutomationFailure(e, t) {
		let r = this.baseUrl + "/ReopenAutomationFailure", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processReopenAutomationFailure(e)));
	}
	processReopenAutomationFailure(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	replayQueueMessage(e, t) {
		let r = this.baseUrl + "/ReplayQueueMessage", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processReplayQueueMessage(e)));
	}
	processReplayQueueMessage(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	resetAgentIntegration(e, t, r, i) {
		let a = this.baseUrl + "/ResetAgentIntegration";
		if (a += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		if (a += "agencyId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'agentId' must be defined and cannot be null.");
		if (a += "agentId=" + encodeURIComponent(f(t)) + "&", r == null) throw new globalThis.Error("The parameter 'provider' must be defined and cannot be null.");
		a += "provider=" + encodeURIComponent(f(r)) + "&", a = a.replace(/[?&]$/, "");
		let o = {
			method: "POST",
			url: a,
			headers: {},
			signal: i
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processResetAgentIntegration(e)));
	}
	processResetAgentIntegration(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 ? M("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	resolveAutomationFailure(e, t) {
		let r = this.baseUrl + "/ResolveAutomationFailure", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processResolveAutomationFailure(e)));
	}
	processResolveAutomationFailure(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	restoreSoftDeletedAgent(e, t) {
		let r = this.baseUrl + "/RestoreSoftDeletedAgent", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processRestoreSoftDeletedAgent(e)));
	}
	processRestoreSoftDeletedAgent(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	setLeaderboardVisibility(e, t) {
		let r = this.baseUrl + "/SetLeaderboardVisibility", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetLeaderboardVisibility(e)));
	}
	processSetLeaderboardVisibility(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	startMigrationRun(e, t) {
		let r = this.baseUrl + "/StartMigrationRun", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStartMigrationRun(e)));
	}
	processStartMigrationRun(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateCampaignStatus(e, t) {
		let r = this.baseUrl + "/UpdateCampaignStatus", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateCampaignStatus(e)));
	}
	processUpdateCampaignStatus(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateContractStatus(e, t) {
		let r = this.baseUrl + "/UpdateContractStatus", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateContractStatus(e)));
	}
	processUpdateContractStatus(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateVendorLegalName(e, t) {
		let r = this.baseUrl + "/UpdateVendorLegalName", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateVendorLegalName(e)));
	}
	processUpdateVendorLegalName(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? M("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : M("An unexpected server error occurred.", e.status, e.data, t);
	}
}, m = /* @__PURE__ */ function(e) {
	return e.Activities = "Activities", e.Agencies = "Agencies", e.CampaignFlow = "CampaignFlow", e.Campaigns = "Campaigns", e.Docusign = "Docusign", e.Marketing = "Marketing", e.Migrator = "Migrator", e.Notifications = "Notifications", e.Pdf = "Pdf", e.Rex = "Rex", e.RpData = "RpData", e.Staff = "Staff", e.TitleSearch = "TitleSearch", e.IdentityVerification = "IdentityVerification", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.Text = "Text", e.Identifier = "Identifier", e.Number = "Number", e.Boolean = "Boolean", e.Enum = "Enum", e.Date = "Date", e.Time = "Time", e.Instant = "Instant", e.LocalDateTime = "LocalDateTime", e.OffsetDateTime = "OffsetDateTime", e.Duration = "Duration", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.ManuallyActioned = "ManuallyActioned", e.Ignored = "Ignored", e.FalseAlarm = "FalseAlarm", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.Email = "Email", e.Crm = "Crm", e.Tasks = "Tasks", e.Documents = "Documents", e.DocuSign = "DocuSign", e.CampaignFlow = "CampaignFlow", e.TitleSearch = "TitleSearch", e.IdentityVerification = "IdentityVerification", e.Marketing = "Marketing", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.InvalidData = "InvalidData", e.ProviderUnavailable = "ProviderUnavailable", e.PermissionDenied = "PermissionDenied", e.RecordNotFound = "RecordNotFound", e.TimedOut = "TimedOut", e.Unexpected = "Unexpected", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.Unresolved = "Unresolved", e.Resolved = "Resolved", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.Agent = "Agent", e.Staff = "Staff", e.Platform = "Platform", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.Agency = "Agency", e.Team = "Team", e.Agent = "Agent", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.Verbose = "Verbose", e.Information = "Information", e.Warning = "Warning", e.Error = "Error", e.Critical = "Critical", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.Sent = "Sent", e.Signed = "Signed", e.Complete = "Complete", e.Declined = "Declined", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.Sent = "Sent", e.Opened = "Opened", e.Signed = "Signed", e.Complete = "Complete", e.Declined = "Declined", e.AutoResponded = "AutoResponded", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.NotRun = "NotRun", e.InProgress = "InProgress", e.Successful = "Successful", e.Failed = "Failed", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.DocuSign = "DocuSign", e.RpData = "RpData", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.Activities = "Activities", e.Agencies = "Agencies", e.CampaignFlow = "CampaignFlow", e.Campaigns = "Campaigns", e.Docusign = "Docusign", e.Marketing = "Marketing", e.Migrator = "Migrator", e.Notifications = "Notifications", e.PDF = "PDF", e.Rex = "Rex", e.RPData = "RPData", e.Staff = "Staff", e.TitleSearch = "TitleSearch", e.IdentityVerification = "IdentityVerification", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.ManuallyActioned = "ManuallyActioned", e.Ignored = "Ignored", e.FalseAlarm = "FalseAlarm", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.Agency = "Agency", e.Team = "Team", e.Agent = "Agent", e;
}({}), te = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e.ProposalDraft = "ProposalDraft", e;
}({}), k = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e.ProposalDraft = "ProposalDraft", e;
}({}), A = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e.ProposalDraft = "ProposalDraft", e;
}({}), j = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isSupportApiException = !0;
	static isSupportApiException(e) {
		return e.isSupportApiException === !0;
	}
};
function M(e, t, n, r, i) {
	throw i ?? new j(e, t, n, r, null);
}
//#endregion
//#region src/useClientContext.tsx
var N = "support";
function P(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var F = (e, t, n) => {
	let r = new p(e);
	return r.setAuthConfig(t, n), P(r);
}, I = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[N] || `${e}/${N}`;
}, L = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = I(i), u = c, d = F(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		let e = F(l, a, i);
		p(e);
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, R = a({}), z = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = L(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(R.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, B = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.disconnectRexListing(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		disconnectRexListing: d,
		disconnectRexListingPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, V = (e, t, n) => {
	let i = r(17), a = n === void 0 || n, s = o(R), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getAgentIntegrationStatus",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== t || i[5] !== s ? (d = (n) => {
		let { signal: r } = n;
		return s.getAgentIntegrationStatus(e, t, r);
	}, i[3] = e, i[4] = t, i[5] = s, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g, error: _, isFetching: v } = u(p), y;
	return i[11] !== m || i[12] !== _ || i[13] !== g || i[14] !== v || i[15] !== h ? (y = {
		data: m,
		isPending: h,
		isError: g,
		error: _,
		isFetching: v
	}, i[11] = m, i[12] = _, i[13] = g, i[14] = v, i[15] = h, i[16] = y) : y = i[16], y;
}, H = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getAgentIntegrationStatus",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, U = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(R), s;
	n[0] === e ? s = n[1] : (s = ["getAutomationFailure", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getAutomationFailure(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, W = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getAutomationFailure", e] });
	}, e[0] = t, e[1] = n), n;
}, G = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(R), s;
	n[0] === e ? s = n[1] : (s = ["getAutomationFailureMetrics", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getAutomationFailureMetrics(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, K = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getAutomationFailureMetrics", e] });
	}, e[0] = t, e[1] = n), n;
}, q = (e, t, n, i, a, s, c, l, d, f, p) => {
	let m = r(33), h = p === void 0 || p, g = o(R), _;
	m[0] !== i || m[1] !== t || m[2] !== a || m[3] !== d || m[4] !== c || m[5] !== l || m[6] !== f || m[7] !== n || m[8] !== e || m[9] !== s ? (_ = [
		"getAutomationFailures",
		e,
		t,
		n,
		i,
		a,
		s,
		c,
		l,
		d,
		f
	], m[0] = i, m[1] = t, m[2] = a, m[3] = d, m[4] = c, m[5] = l, m[6] = f, m[7] = n, m[8] = e, m[9] = s, m[10] = _) : _ = m[10];
	let v = _, y;
	m[11] !== i || m[12] !== g || m[13] !== t || m[14] !== a || m[15] !== d || m[16] !== c || m[17] !== l || m[18] !== f || m[19] !== n || m[20] !== e || m[21] !== s ? (y = (r) => {
		let { signal: o } = r;
		return g.getAutomationFailures(e, t, n, i, a, s, c, l, d, f, o);
	}, m[11] = i, m[12] = g, m[13] = t, m[14] = a, m[15] = d, m[16] = c, m[17] = l, m[18] = f, m[19] = n, m[20] = e, m[21] = s, m[22] = y) : y = m[22];
	let b = h && !!g, x;
	m[23] !== v || m[24] !== y || m[25] !== b ? (x = {
		queryKey: v,
		queryFn: y,
		enabled: b
	}, m[23] = v, m[24] = y, m[25] = b, m[26] = x) : x = m[26];
	let { data: S, isPending: C, isError: w, error: T, isFetching: E } = u(x), D;
	return m[27] !== S || m[28] !== T || m[29] !== w || m[30] !== E || m[31] !== C ? (D = {
		data: S,
		isPending: C,
		isError: w,
		error: T,
		isFetching: E
	}, m[27] = S, m[28] = T, m[29] = w, m[30] = E, m[31] = C, m[32] = D) : D = m[32], D;
}, J = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i, a, o, s, c, l, u) => {
		await t.invalidateQueries({ queryKey: [
			"getAutomationFailures",
			e,
			n,
			r,
			i,
			a,
			o,
			s,
			c,
			l,
			u
		] });
	}, e[0] = t, e[1] = n), n;
}, Y = (e, t, n, i, a) => {
	let s = r(21), c = a === void 0 || a, l = o(R), d;
	s[0] !== t || s[1] !== e || s[2] !== n || s[3] !== i ? (d = [
		"getCommonInformationForMessage",
		e,
		t,
		n,
		i
	], s[0] = t, s[1] = e, s[2] = n, s[3] = i, s[4] = d) : d = s[4];
	let f = d, p;
	s[5] !== t || s[6] !== e || s[7] !== l || s[8] !== n || s[9] !== i ? (p = (r) => {
		let { signal: a } = r;
		return l.getCommonInformationForMessage(e, t, n, i, a);
	}, s[5] = t, s[6] = e, s[7] = l, s[8] = n, s[9] = i, s[10] = p) : p = s[10];
	let m = c && !!l, h;
	s[11] !== f || s[12] !== p || s[13] !== m ? (h = {
		queryKey: f,
		queryFn: p,
		enabled: m
	}, s[11] = f, s[12] = p, s[13] = m, s[14] = h) : h = s[14];
	let { data: g, isPending: _, isError: v, error: y, isFetching: b } = u(h), x;
	return s[15] !== g || s[16] !== y || s[17] !== v || s[18] !== b || s[19] !== _ ? (x = {
		data: g,
		isPending: _,
		isError: v,
		error: y,
		isFetching: b
	}, s[15] = g, s[16] = y, s[17] = v, s[18] = b, s[19] = _, s[20] = x) : x = s[20], x;
}, X = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i) => {
		await t.invalidateQueries({ queryKey: [
			"getCommonInformationForMessage",
			e,
			n,
			r,
			i
		] });
	}, e[0] = t, e[1] = n), n;
}, Z = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(R), s;
	n[0] === e ? s = n[1] : (s = ["getLeaderboardVisibilityDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getLeaderboardVisibilityDetails(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, Q = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getLeaderboardVisibilityDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, ne = (e, t, n) => {
	let i = r(17), a = n === void 0 || n, s = o(R), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getLogsForServiceAtPeriod",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getLogsForServiceAtPeriod(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g, error: _, isFetching: v } = u(p), y;
	return i[11] !== m || i[12] !== _ || i[13] !== g || i[14] !== v || i[15] !== h ? (y = {
		data: m,
		isPending: h,
		isError: g,
		error: _,
		isFetching: v
	}, i[11] = m, i[12] = _, i[13] = g, i[14] = v, i[15] = h, i[16] = y) : y = i[16], y;
}, re = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getLogsForServiceAtPeriod",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, ie = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(R), s;
	n[0] === e ? s = n[1] : (s = ["getManualDocuSignUpdateCampaignDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getManualDocuSignUpdateCampaignDetails(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, ae = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getManualDocuSignUpdateCampaignDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, oe = (e) => {
	let t = r(12), n = e === void 0 || e, i = o(R), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getMigrations"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getMigrations(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p, error: m, isFetching: h } = u(l), g;
	return t[6] !== d || t[7] !== m || t[8] !== p || t[9] !== h || t[10] !== f ? (g = {
		data: d,
		isPending: f,
		isError: p,
		error: m,
		isFetching: h
	}, t[6] = d, t[7] = m, t[8] = p, t[9] = h, t[10] = f, t[11] = g) : g = t[11], g;
}, se = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getMigrations"] });
	}, e[0] = t, e[1] = n), n;
}, ce = (e, t, n) => {
	let i = r(17), a = n === void 0 || n, s = o(R), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getPoisonQueueMessages",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getPoisonQueueMessages(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g, error: _, isFetching: v } = u(p), y;
	return i[11] !== m || i[12] !== _ || i[13] !== g || i[14] !== v || i[15] !== h ? (y = {
		data: m,
		isPending: h,
		isError: g,
		error: _,
		isFetching: v
	}, i[11] = m, i[12] = _, i[13] = g, i[14] = v, i[15] = h, i[16] = y) : y = i[16], y;
}, le = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getPoisonQueueMessages",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, ue = (e) => {
	let t = r(12), n = e === void 0 || e, i = o(R), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getPoisonQueues"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getPoisonQueues(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p, error: m, isFetching: h } = u(l), g;
	return t[6] !== d || t[7] !== m || t[8] !== p || t[9] !== h || t[10] !== f ? (g = {
		data: d,
		isPending: f,
		isError: p,
		error: m,
		isFetching: h
	}, t[6] = d, t[7] = m, t[8] = p, t[9] = h, t[10] = f, t[11] = g) : g = t[11], g;
}, de = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getPoisonQueues"] });
	}, e[0] = t, e[1] = n), n;
}, fe = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(R), s;
	n[0] === e ? s = n[1] : (s = ["getRexDisconnectionCampaignDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getRexDisconnectionCampaignDetails(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, pe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getRexDisconnectionCampaignDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, me = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(R), s;
	n[0] === e ? s = n[1] : (s = ["getSoftDeletedAgentsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getSoftDeletedAgentsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, he = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getSoftDeletedAgentsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, ge = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(R), s;
	n[0] === e ? s = n[1] : (s = ["getUpdateCampaignStatusDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getUpdateCampaignStatusDetails(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, _e = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getUpdateCampaignStatusDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, ve = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(R), s;
	n[0] === e ? s = n[1] : (s = ["getUpdateLegalNameCampaignDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getUpdateLegalNameCampaignDetails(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, ye = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getUpdateLegalNameCampaignDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, be = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.reopenAutomationFailure(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		reopenAutomationFailure: d,
		reopenAutomationFailurePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, $ = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.replayQueueMessage(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		replayQueueMessage: d,
		replayQueueMessagePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, xe = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { agencyId: t, agentId: n, provider: r } = e;
		return s.resetAgentIntegration(t, n, r);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		resetAgentIntegration: d,
		resetAgentIntegrationPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Se = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.resolveAutomationFailure(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		resolveAutomationFailure: d,
		resolveAutomationFailurePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Ce = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.restoreSoftDeletedAgent(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		restoreSoftDeletedAgent: d,
		restoreSoftDeletedAgentPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, we = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.setLeaderboardVisibility(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		setLeaderboardVisibility: d,
		setLeaderboardVisibilityPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Te = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.startMigrationRun(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		startMigrationRun: d,
		startMigrationRunPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Ee = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.updateCampaignStatus(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		updateCampaignStatus: d,
		updateCampaignStatusPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, De = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.updateContractStatus(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		updateContractStatus: d,
		updateContractStatusPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Oe = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(R), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.updateVendorLegalName(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		updateVendorLegalName: d,
		updateVendorLegalNamePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
};
//#endregion
export { m as AgxService, h as AutomationContextAttributeType, g as AutomationFailureResolutionType, _ as AutomationFailureResponseArea, v as AutomationFailureResponseReason, y as AutomationFailureResponseStatus, b as AutomationFailureResponseUserType, x as LeaderboardEntityVisibilitySummaryEntityType, S as LogEntrySeverityLevel, C as ManualDocuSignUpdateEnvelopeDetailsStatus, w as ManualDocuSignUpdateRecipientDetailsStatus, T as MigrationRunDetailsStatus, E as Provider, D as ReplayQueueMessageRequestService, O as ResolveAutomationFailureRequestResolution, ee as SetLeaderboardVisibilityRequestEntityType, R as SupportApiContext, j as SupportApiException, z as SupportApiProvider, p as SupportClient, N as SupportRoute, te as UpdateCampaignStatusCampaignDetailsCurrentStage, k as UpdateCampaignStatusRequestStage, A as UpdateCampaignStatusStageOptionStage, B as useDisconnectRexListing, V as useGetAgentIntegrationStatus, U as useGetAutomationFailure, G as useGetAutomationFailureMetrics, q as useGetAutomationFailures, Y as useGetCommonInformationForMessage, Z as useGetLeaderboardVisibilityDetails, ne as useGetLogsForServiceAtPeriod, ie as useGetManualDocuSignUpdateCampaignDetails, oe as useGetMigrations, ce as useGetPoisonQueueMessages, ue as useGetPoisonQueues, fe as useGetRexDisconnectionCampaignDetails, me as useGetSoftDeletedAgentsForAgency, ge as useGetUpdateCampaignStatusDetails, ve as useGetUpdateLegalNameCampaignDetails, H as useInvalidateUseGetAgentIntegrationStatus, W as useInvalidateUseGetAutomationFailure, K as useInvalidateUseGetAutomationFailureMetrics, J as useInvalidateUseGetAutomationFailures, X as useInvalidateUseGetCommonInformationForMessage, Q as useInvalidateUseGetLeaderboardVisibilityDetails, re as useInvalidateUseGetLogsForServiceAtPeriod, ae as useInvalidateUseGetManualDocuSignUpdateCampaignDetails, se as useInvalidateUseGetMigrations, le as useInvalidateUseGetPoisonQueueMessages, de as useInvalidateUseGetPoisonQueues, pe as useInvalidateUseGetRexDisconnectionCampaignDetails, he as useInvalidateUseGetSoftDeletedAgentsForAgency, _e as useInvalidateUseGetUpdateCampaignStatusDetails, ye as useInvalidateUseGetUpdateLegalNameCampaignDetails, be as useReopenAutomationFailure, $ as useReplayQueueMessage, xe as useResetAgentIntegration, Se as useResolveAutomationFailure, Ce as useRestoreSoftDeletedAgent, we as useSetLeaderboardVisibility, Te as useStartMigrationRun, L as useSupportClientContext, Ee as useUpdateCampaignStatus, De as useUpdateContractStatus, Oe as useUpdateVendorLegalName };
